/* eslint-disable arrow-body-style */
import { defineAsyncComponent } from 'vue';
/**
 * Async import components (MAIN)
 */
const TheIcon = defineAsyncComponent(() => import('@/components/icon/TheIcon.vue'));
/**
 * Import all componenet asynchronously in here
 */
const SortTable = defineAsyncComponent(() => import('@/components/icon/SortTable.vue'));
const ArrowBack = defineAsyncComponent(() => import('@/components/icon/ArrowBack.vue'));
const CaretDown = defineAsyncComponent(() => import('@/components/icon/CaretDown.vue'));
const BellFill = defineAsyncComponent(() => import('@/components/icon/BellFill.vue'));
const Calendar = defineAsyncComponent(() => import('@/components/icon/Calendar.vue'));
const Clear = defineAsyncComponent(() => import('@/components/icon/Clear.vue'));
const Star = defineAsyncComponent(() => import('@/components/icon/Star.vue'));
/**
 * Initialize icons component
 * @param app vue instance
 */
export function initIcons(app) {
    // Main component
    app.component('SvgIcon', TheIcon);
    // Icons
    app.component('SortTable', SortTable);
    app.component('ArrowBack', ArrowBack);
    app.component('CaretDown', CaretDown);
    app.component('BellFill', BellFill);
    app.component('Calendar', Calendar);
    app.component('Clear', Clear);
    app.component('Star', Star);
}
